import Image from 'next/image';
import React from 'react';

import Container from '@/components/Container';

const HowItWorksMerch = () => {
  return (
    <Container>
      <div className='flex flex-col md:flex-row justify-around items-center py-2 rounded-xl md:space-x-4'>
        <Step
          number={1}
          title='Upload your photos'
          image='/images/lp/t-shirt/upload-your-selfie.png'
          alt='Dog selfie'
          className='w-full md:w-1/3 max-w-sm'
        />
        <Step
          number={2}
          title='Generate your Sketches'
          content={<SketchGrid />}
          className='w-full md:w-1/3 max-w-sm'
        />
        <Step
          number={3}
          title='Select your T-Shirt Design to Purchase'
          image='/images/lp/t-shirt/how-it-works-t-shirt.jpeg'
          alt='T-shirt with dog sketch'
          className='w-full md:w-1/3 max-w-sm'
        />
      </div>
    </Container>
  );
};

const Step = ({
  number,
  title,
  image,
  alt,
  content,
  className,
}: {
  number: number;
  title: string;
  image?: string;
  alt?: string;
  content?: React.ReactNode;
  className?: string;
}) => (
  <div
    className={`flex flex-col items-center mb-8 md:mb-0 px-2 ${className || ''}`}
  >
    <div className='text-xl sm:text-2xl md:text-3xl font-bold mb-4 text-gray-800 text-center'>
      {number}. {title}
    </div>
    {image ? (
      <Image
        src={image}
        alt={alt || ''}
        width={300}
        height={300}
        className='rounded-full object-cover border-2 border-gray-500'
      />
    ) : (
      content
    )}
  </div>
);

const SketchGrid = () => (
  <div className='grid grid-cols-2 gap-4'>
    {[1, 2, 3, 4].map((i) => (
      <Image
        key={i}
        src={`/images/lp/t-shirt/generated-sketch-${i}.jpeg`}
        alt={`Dog sketch ${i}`}
        width={150}
        height={150}
        className='rounded-full object-cover border-2 border-gray-500'
      />
    ))}
  </div>
);

export default HowItWorksMerch;
